import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environment/environment";
import { SaveSiteMicRequestVM, SaveSiteMicResponseVM } from "@models/backend-generated-models/models";
import { Observable } from "rxjs";

/**
 * Saving the MIC a client enters in the what-if. The site's current one is read back with the chart's
 * own data, so there is no separate load.
 *
 * Errors are left to the caller, as for the tariff rates: a refused figure comes back with a sentence
 * saying what is wrong with it, and the panel shows that beside the box instead of in a toast.
 */
@Injectable({ providedIn: 'root' })
export class MicService {
    constructor(private httpClient: HttpClient) {}

    /** The window is the measured demand's, so the hours at or over the new figure come back with it. */
    saveMic$(siteId: number, micKva: number, windowFrom?: Date, windowTo?: Date): Observable<SaveSiteMicResponseVM> {
        const body: SaveSiteMicRequestVM = { siteId, micKva, windowFrom, windowTo };
        return this.httpClient.put<SaveSiteMicResponseVM>(`${environment.apiUrl}mic`, body);
    }
}
